import { asyncDataFetchReducer } from '@buffer-mono/async-data-fetch'

import { aiLimitsSlice } from '~publish/legacy/ai/state/aiLimits/slice'
import { contentGenerationSlice } from '~publish/legacy/ai/state/contentGeneration/slice'
import { contentIdeationSlice } from '~publish/legacy/ai/state/contentIdeation/slice'
import { AISlice } from '~publish/legacy/ai/state/slice'
import coachmarksReducer from '~publish/legacy/coachmarks/reducer'
import generalSettingsReducer from '~publish/legacy/general-settings/reducer'
import guidesReducer from '~publish/legacy/guides/reducer'
import hashtagGroupsReducer from '~publish/legacy/hashtag-group-manager/reducer'
import i18nReducer from '~publish/legacy/i18n/reducer'
import { integrationBarSlice } from '~publish/legacy/integrations-bar/state/integrationBarSlice'
import modalsReducer from '~publish/legacy/modals/reducer'
import orgReducer from '~publish/legacy/organizations/reducer'
import { postsSlice } from '~publish/legacy/post/slice'
import profileNavReducer from '~publish/legacy/profile-nav/reducer'
import profileSidebarReducer from '~publish/legacy/profile-sidebar/reducer'
import profilesDisconnectedModalReducer from '~publish/legacy/profiles-disconnected-modal/reducer'
import remindersReducer from '~publish/legacy/reminders/reducer'
import { uploadsSlice } from '~publish/legacy/uploads/state/slice'

export const reducers = {
  organizations: orgReducer,
  profileNav: profileNavReducer,
  i18n: i18nReducer,
  profileSidebar: profileSidebarReducer,
  asyncDataFetch: asyncDataFetchReducer,
  modals: modalsReducer,
  generalSettings: generalSettingsReducer,
  profilesDisconnectedModal: profilesDisconnectedModalReducer,
  hashtagGroups: hashtagGroupsReducer,
  coachmarks: coachmarksReducer,
  guides: guidesReducer,
  reminders: remindersReducer,
  // this manual wiring could be simplified with Redux Toolkit configureStore
  [postsSlice.name]: postsSlice.reducer,
  [uploadsSlice.name]: uploadsSlice.reducer,
  [aiLimitsSlice.name]: aiLimitsSlice.reducer,
  [contentIdeationSlice.name]: contentIdeationSlice.reducer,
  [integrationBarSlice.name]: integrationBarSlice.reducer,
  [contentGenerationSlice.name]: contentGenerationSlice.reducer,
  [AISlice.name]: AISlice.reducer,
}
